import { MobileLayoutProps, MobileLayoutEditorProps, MenuItem } from './MobileLayout.types';

/**
 * 기존 데이터 형식을 새로운 형식으로 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 새로운 컴포넌트용 props
 */
export function adaptMobileLayoutProps(originalProps: any): MobileLayoutProps {
  // 기본값 설정 (빈 객체로 초기화)
  const originalContent = originalProps?.content || {};
  const originalData = originalProps?.data || {};
  const originalComponentProps = originalProps?.componentProps || {};
  
  // 메뉴 아이템 추출
  const menuItems = originalComponentProps?.menuItems || originalContent?.menuItems || originalData?.menuItems || [
    { label: '내 정보', path: '/mydata' },
    { label: '자산정보', path: '/points' },
    { label: '추천인', path: '/recommendee' },
    { label: '계보도', path: '/legs' },
    { label: '멤버십투자', path: '/getmembership' },
    { label: '수당요약', path: '/getPaybacks' },
  ];

  // 스크롤 화살표 표시 여부
  const showArrows = 
    originalComponentProps?.showArrows !== undefined ? originalComponentProps.showArrows :
    originalContent?.showArrows !== undefined ? originalContent.showArrows :
    originalData?.showArrows !== undefined ? originalData.showArrows : 
    true;

  // 배경색
  const backgroundColor = 
    originalComponentProps?.backgroundColor || 
    originalContent?.backgroundColor || 
    originalData?.backgroundColor || 
    '#fff';

  // 텍스트 색상
  const textColor = 
    originalComponentProps?.textColor || 
    originalContent?.textColor || 
    originalData?.textColor || 
    '#000';

  // 선택 텍스트 색상
  const activeTextColor = 
    originalComponentProps?.activeTextColor || 
    originalContent?.activeTextColor || 
    originalData?.activeTextColor || 
    '#3b82f6';

  // 스크롤량
  const scrollAmount = 
    originalComponentProps?.scrollAmount || 
    originalContent?.scrollAmount || 
    originalData?.scrollAmount || 
    100;

  // 스타일 병합 (깊은 복사로 병합)
  const style = {
    ...(originalProps?.style || {}),
    ...(originalComponentProps?.style || {})
  };
  
  // 인라인 스타일과 CSS 클래스 통합
  if (originalProps.defaultStyle) {
    Object.assign(style, originalProps.defaultStyle);
  }

  // className 설정
  const className = originalProps?.className || originalComponentProps?.className || '';

  // 변환된 props 반환
  const adaptedProps: MobileLayoutProps = {
    style,
    className,
    menuItems,
    showArrows,
    data: originalData,
    componentProps: {
      ...originalComponentProps,
      menuItems,
      showArrows,
      backgroundColor,
      textColor,
      activeTextColor,
      scrollAmount
    },
    content: { 
      ...originalContent 
    },
    id: originalProps?.id || '',
  };

  // 원본 props의 모든 속성 중 이미 처리한 속성 제외하고 나머지 복사
  const excludeKeys = ['content', 'style', 'className', 'data', 'componentProps', 'id', 'menuItems', 'showArrows'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 에디터용 데이터 형식 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptMobileLayoutEditorProps(originalProps: any): MobileLayoutEditorProps {
  // 기본 props 변환 사용
  const adaptedProps = adaptMobileLayoutProps(originalProps) as MobileLayoutProps;
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 